import Layout from "./containers/Layout";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { changeTheme } from "./features/themeSlice";
import { Route, Routes, useNavigate } from "react-router-dom";
import { isMobile } from "react-device-detect";
import { cssTransition, ToastContainer } from "react-toastify";
import { MultipliedIcon } from "./assets/icons";
import Login from "./pages/Login";
import PaymentResult from "./pages/PaymentResult";
import { persistStore } from "redux-persist";
import { store } from "./app/store";
import { deleteToken } from "./actions";

const App = () => {
  const persistor = persistStore(store);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const Token = localStorage.getItem("Token");
  const removeToken = () => dispatch(deleteToken());
  const customSlide = cssTransition({
    enter: isMobile
      ? "animate__animated animate__fadeInUp"
      : "animate__animated animate__fadeInRight",
    exit: isMobile
      ? "animate__animated animate__fadeOutDown"
      : "animate__animated animate__fadeOutRight",
  });

  useEffect(() => {
    if (!Token) {
      persistor.pause();
      persistor.flush().then(() => {
        return persistor.purge();
      });
      removeToken();
      navigate("/login");
    }
  }, [Token, navigate]);

  useEffect(() => {
    if (
      localStorage.theme === "dark" ||
      (!("theme" in localStorage) &&
        window.matchMedia("(prefers-color-scheme: dark)").matches)
    ) {
      document.documentElement.classList.add("dark");
      dispatch(changeTheme("dark"));
    } else {
      document.documentElement.classList.remove("dark");
      dispatch(changeTheme("light"));
    }
  }, [dispatch]);

  return (
    <>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/PaymentResult/Verify" element={<PaymentResult />} />
        <Route path="/*" element={<Layout />} />
      </Routes>
      <ToastContainer
        role="alert"
        position="bottom-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={true}
        pauseOnHover={false}
        pauseOnFocusLoss={false}
        closeOnClick
        rtl={true}
        closeButton={({ closeToast }) => (
          <MultipliedIcon onClick={closeToast} />
        )}
        transition={customSlide}
        draggable
        bodyClassName="font-bold"
      />
    </>
  );
};

export default App;
